module.exports = __webpack_public_path__ + "media/fonts/SFProText-Bold-93e56d3430bdec33eaff83910a3f95d0.woff2";